import { useEffect, useReducer } from 'react';

/**
 * 订阅权限变化，让菜单/页面在登录后或刷新后重新渲染。
 */
export default function usePermissionVersion() {
  const [version, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const handler = () => forceUpdate();
    window.addEventListener('permissions-updated', handler);
    return () => window.removeEventListener('permissions-updated', handler);
  }, []);

  return version;
}
